import { useState } from "react";
import { Spinner } from "react-bootstrap";
import CustomSvg from "../components/svgs/CustomSvg";
import { useNavigate } from "react-router-dom";

const GateFeeModal = ({
  isOpen,
  onClose,
  onSuccess,
  gameId,
  tournamentId,
  prizes,
  submitPrizes
}) => {
  const [value, setValue] = useState("0");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  if (!isOpen) return null;

  const onIncrement = () => {
    const current = parseInt(value || "0", 10);
    if (current < 25000) setValue(String(current + 100));
  };

  const onDecrement = () => {
    const current = parseInt(value || "0", 10);
    if (current - 100 >= 100) setValue(String(current - 100));
  };

  const handleInputChange = (e) => {
    const val = e.target.value.replace(/,/g, "");
    if (val === "") return setValue("");
    if (!/^\d+$/.test(val)) return;
    const inputValue = parseInt(val, 10);
    if (inputValue <= 25000) setValue(val);
  };

  const formatWithCommas = (numStr) =>
    !numStr ? "" : parseInt(numStr, 10).toLocaleString("en-NG");

  const handleSubmit = async () => {
    const current = parseInt(value || "0", 10);
    if (current >= 100) {
      setLoading(true);
      await submitPrizes({
        hasGateFee: true,
        gateFee: current * 100,
      });
      setLoading(false);
      onSuccess?.();
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="bg-[#130828] p-6 rounded-xl w-full max-w-md text-white relative">
        <button className="absolute top-4 right-4" onClick={onClose}>
          <CustomSvg name="close" />
        </button>

        <h2 className="text-xl mb-4 text-center font-bold bg-gradient-to-r from-[#C6BCFF] to-[#3F9217] bg-clip-text text-transparent">
          Set Gate Fee
        </h2>

        <div className="flex justify-between items-center mb-6">
          <button onClick={onDecrement} className="bg-gray-700 p-2 rounded-md">
            <CustomSvg name="minus" />
          </button>

          <input
            type="text"
            value={value === "" ? "" : formatWithCommas(value)}
            onChange={handleInputChange}
            className="bg-transparent text-lg text-white text-center border-b-2 border-white w-32"
          />

          <button onClick={onIncrement} className="bg-gray-700 p-2 rounded-md">
            <CustomSvg name="plus" />
          </button>
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full py-2 rounded bg-green-600 hover:bg-green-700 transition-colors"
        >
          {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
        </button>

        <button
          onClick={() => {
            submitPrizes({
              hasGateFee: false,
              gateFee: 0,
            });
            onClose();
          }}
          className="mt-3 w-full py-2 text-sm text-gray-300 underline"
        >
          Skip Gate Fee
        </button>
      </div>
    </div>
  );
};

export default GateFeeModal;
